module.exports = __webpack_public_path__ + "static/media/Danone_Regular.9c922cb9.woff2";